import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import AuthenticationServices from "../../services/axiosServices/apiServices/AuthenticationServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { setAuthProps } from "../../utils/AuthenticationLibrary";
import { ErrorMessage } from "../../utils/Messages";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { MsalContext } from "@azure/msal-react";
import { withMsal } from "@azure/msal-react";
import { loginRequest, msalConfig } from "../../HOC/authConfig";
import { InteractionStatus, PublicClientApplication } from "@azure/msal-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightToBracket } from "@fortawesome/free-solid-svg-icons";
const msalInstance = new PublicClientApplication(msalConfig);

class Login extends Component {
  static contextType = MsalContext;
  constructor(props) {
    super(props);
    this.authServices = new AuthenticationServices();
    this.swalServices = new SwalServices();

    this.state = {
      currentStep: 1,
      isLoading: false,
      redirect: "",
      companyDetails: {
        companyName: "",
        financialYear: "",
      },
      userDetails: {
        userName: "",
        password: "",
        databaseName: "",
        idCompany: "",
        currentDateTimeFromUserSystem: "",
      },
      validationRules: {
        userName: [
          {
            type: "require",
            message: ErrorMessage.FieldRequired.replace("{0}", "Email address"),
          },
          {
            type: "email",
            message: ErrorMessage.NOTVALIDPATTERN.replace(
              "{0}",
              "Email address"
            ),
          },
        ],
        password: [
          {
            type: "require",
            message: ErrorMessage.FieldRequired.replace("{0}", "Password"),
          },
          //   { type: 'password', message: ErrorMessage.PasswordNotValid }
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      masterCompanyList: [],
      masterCompanySelectList: [],
    };
  }

  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.userDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };

  isValidateAllFields = () => {
    const newValidState = isValidForm(
      this.state.userDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  // login = () => {
  //   if (this.isValidateAllFields()) {
  //     this.setState({ isLoading: true });
  //     let request = { ...this.state.userDetails }
  //     let currentdate = new Date();
  //     let currentDateTime = currentdate.getMonth() + 1 + "-" + currentdate.getDate() + "-" + currentdate.getFullYear() + " " +
  //       currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();
  //     request.currentDateTimeFromUserSystem = currentDateTime;
  //     if (request.isTwoFactor === false) {
  //       request.varificationCode = "";
  //     }
  //     this.authServices.adminLogin(request).then((response) => {
  //       if (response.responseItem.responseContent.isLocked === true) {
  //         this.swalServices.Error(response.responseItem.responseContent.message);
  //       } else if (response.statusCode === 200 && response.responseItem) {
  //         if (response.responseItem.responseContent.isTwoFactor && response.responseItem.responseContent.isTwoFactor === true) {
  //           let user = { ...this.state.userDetails };
  //           user.isTwoFactor = true;
  //           this.setState({ userDetails: user })
  //         } else {
  //           let authDetails = response.responseItem.responseContent;
  //           setAuthProps(authDetails);
  //           // this.setState({ route: "/Dashboard" });
  //           window.location.href = "/Dashboard";
  //         }
  //       } else {
  //         this.swalServices.Error(ErrorMessage.InvalidAuthorization);
  //       }
  //       this.setState({ isLoading: false });
  //     });
  //   }
  // };

  login(loginAs) {
    //this.setState({ isLoading: true });
    localStorage.removeItem('CurrentLevel')
    localStorage.removeItem('CurrentMainModuleId')
    localStorage.removeItem('CurrentParentSubModuleId')
    let request = this.state.userDetails;
    request.loginAs = loginAs;
    let currentdate = new Date();
    let currentDateTime = currentdate.getMonth() + 1 + "-" + currentdate.getDate() + "-" + currentdate.getFullYear() + " " +
      currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();
    request.currentDateTimeFromUserSystem = currentDateTime;
    this.authServices.login(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem) {
        let authDetails = response.responseItem.responseContent[0];
        if (loginAs === 'Admin') {
          authDetails.loginType = 'Admin'
        } else if (loginAs === 'HOD') {
          authDetails.loginType = 'HOD'
        } else if (loginAs === 'User') {
          authDetails.loginType = 'USER'
        }
        setAuthProps(authDetails);
        this.setState({}, () => {
          //let data = getCookie('TokenA111')
          if (loginAs === 'Admin') {
            window.location.href = "/dashboard";
          } else if (loginAs === 'HOD') {
            window.location.href = "/dashboard";
          } else if (loginAs === 'User') {
            window.location.href = "/dashboard";
          }
        })
      }
      else {
        this.swalServices.Error(ErrorMessage.InvalidAuthorization);
      }
      //this.setState({ isLoading: false });
    });
  }

  // loginWithVerificationCode = () => {
  //   if (this.isValidateAllFields()) {
  //     this.setState({ isLoading: true });
  //     this.authServices.adminLoginWithVarificationCode(this.state.userDetails).then((response) => {
  //       if (response.responseItem.responseContent.isLocked === true) {
  //         this.swalServices.Error(response.responseItem.responseContent.message);
  //       }
  //       else if (response.statusCode === 200 && response.responseItem) {
  //           let authDetails = response.responseItem.responseContent;
  //           setAuthProps(authDetails);
  //           // this.setState({ route: "/Dashboard" });
  //           window.location.href = "/Dashboard";
  //       } else {
  //         this.swalServices.Error(ErrorMessage.InvalidAuthorization);
  //       }
  //       this.setState({ isLoading: false });
  //     });
  //   }
  // };

  handleLogin(loginType) {
    this.setState({ isLoading: true });
    msalInstance["browserStorage"].clear();
    const isAuthenticated = this.props.msalContext.accounts.length > 0;
    if (!isAuthenticated && this.props.msalContext.inProgress === InteractionStatus.None) {
      msalInstance.loginPopup(loginRequest).then(response => {
        localStorage.setItem("homeAccountId", JSON.stringify(response.account.homeAccountId));
        // let azureusername = response.account.username;
        let req = {};
        req.username = response.account.username;
        this.authServices.azureLogin(req).then((response) => {
          if (response.statusCode === 200 && response.responseItem) {
            let authDetails = response.responseItem.responseContent;
            setAuthProps(authDetails);
            window.location.href = "/dashboard";
          }
          else {
            this.swalServices.Error(ErrorMessage.InvalidAuthorization);
          }
          this.setState({ isLoading: false });
        });
      })
        .catch(err => {
          // handle error
          if (err.errorCode === "interaction_in_progress") {
            this.handleLogin("popup");
          }
        });
    }

  }

  selectedCompany = (e) => {
    const selectedCompany = e.target.value;
    let details = this.state.companyDetails;
    details.companyName = selectedCompany;
    this.setState({ companyDetails: details });
  };

  handleYearChange = (e) => {
    const selectedYear = e.target.value;
    let details = this.state.companyDetails;
    details.financialYear = selectedYear;
    this.setState({ companyDetails: details });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.userDetails;
    if (name === "userName") {
      details[name] = value
    } else {
      details[name] = value
    }
    this.setState({ userDetails: details });
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      this.userAuthentication();
    }
  };

  goToNextStep = () => {
    this.setState((prevState) => ({
      currentStep: prevState.currentStep + 1,
    }));
  };
  goToPreviousStep = () => {
    this.setState((prevState) => ({
      currentStep: prevState.currentStep - 1,
    }));
  };
  getMasterCompanyList = () => {
    this.authServices.getMasterCompanyList().then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        //debugger;
        this.setState({ masterCompanyList: response.responseItem.responseContent })
      }
    });
  }

  selectedDatabase = (databasename) => {
    let request = {
      databaseName: databasename,
    }
    this.authServices.selectedDatabase(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        //debugger;
        this.setState({ masterCompanySelectList: response.responseItem.responseContent }, () => {
          let data = this.state.userDetails;
          data.databaseName = databasename;
          this.setState({ userDetails: data })
          this.goToNextStep()
        });
      }
    });
  }

  selectedCompanyname = (idCompany, companyName) => {
    let data = this.state.userDetails;
    data.idCompany = idCompany;
    let details = this.state.companyDetails;
    details.companyName = companyName;
    this.setState({ userDetails: data, companyDetails: details }, () => {
      this.goToNextStep()
    });
  }

  componentDidMount = () => {
    // Add the event listener when the component mounts
    window.addEventListener("keydown", this.handleKeyDown);

    this.getMasterCompanyList();
  }

  componentWillUnmount() {
    //debugger;
    // Remove the event listener when the component unmounts
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    // Check if "Ctrl + L" is pressed
    //debugger;
    if (event.ctrlKey && event.key.toLowerCase() === "l") {
      event.preventDefault(); // Prevent default browser behavior
      let data = this.state.userDetails;
      data.userName = "";
      data.password = "";
      //data.databaseName = "";
      this.setState({ currentStep: 4, userDetails: data });
    }
    else if (event.ctrlKey && event.key.toLowerCase() === "h") {
      event.preventDefault(); // Prevent default browser behavior
      let data = this.state.userDetails;
      data.userName = "";
      data.password = "";
      this.setState({ currentStep: 5, userDetails: data });
    }
    else if (event.ctrlKey && event.key.toLowerCase() === "u") {
      event.preventDefault(); // Prevent default browser behavior
      let data = this.state.userDetails;
      data.userName = "";
      data.password = "";
      this.setState({ currentStep: 3, userDetails: data });
    }
  };

  render() {
    const { currentStep } = this.state;
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }

    return (
      <div className="login-page flex items-center justify-center h-[100vh]">
        <div className="login rounded-3xl shadow-blueShadow w-[80%] flex">
          <div className="login-image w-[40%] aspect-[3/4]">
            <img className="h-full object-cover" src="/login-image.png" alt="Log in" />
          </div>
          <div className="login-form bg-body py-[40px] px-[70px] w-[60%] content-center">
            {currentStep === 1 && (
              <div className="login-stepOne grid gap-[10px]">
                <div className="step-inner">
                  <div className="step-content w-[80%] mx-auto">
                    <h1 className="text-4xl font-bold mb-[10px] text-center text-[#3f8cff]">Welcome</h1>
                    <p className="font-medium mb-[40px] text-center text-[#677e97]">Select your company from the list below or you can create a new company if it does not exist in the list.</p>
                  </div>
                  <div className="table-selector">
                    <table className="shadow-normalShadow w-full">
                      <thead className=" text-blue">

                        <tr>
                          <td className="p-[10px] w-[15%]">Sr. No.</td>
                          <td className="p-[10px] w-[45%]">Company name</td>
                          <td className="p-[10px] w-[25%]">Database name</td>
                          <td className="p-[10px] text-center w-15">Action</td>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.masterCompanyList && this.state.masterCompanyList.map((x) => {
                          return (
                            <>
                              {x.companyName && x.databasename ?
                                <tr>
                                  <td>{x.srNo}</td>
                                  <td>{x.companyName}</td>
                                  <td>{x.databasename}</td>
                                  <td><button className="secondary-btn w-full" onClick={() => this.selectedDatabase(x.databasename)} >Connect</button></td>
                                </tr>
                                :
                                null
                              }
                            </>
                          )
                        })}
                        {/*<tr>
                          <td>1</td>
                          <td>Mascot1</td>
                          <td>db2023</td>
                          <td><button className="secondary-btn w-full justify-center">Connect</button></td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>Mascot2</td>
                          <td>db2023</td>
                          <td><button className="secondary-btn w-full justify-center">Connect</button></td>
                        </tr>*/}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="btn-grp flex justify-between mt-[30px] w-full">
                  <button className="secondary-btn">Create company</button>
                  {/* <button className="prm-btn" onClick={this.goToNextStep}>Next <FontAwesomeIcon icon={faArrowRightLong} /></button> */}
                </div>
              </div>
            )}
            {currentStep === 2 && (
              <div className="login-stepTwo grid gap-[10px]">
                <div className="step-inner">
                  <div className="step-content w-[80%] mx-auto">
                    <h1 className="text-4xl font-bold mb-[10px] text-center text-[#3f8cff]">Company details</h1>
                    <p className="font-medium mb-[40px] text-center text-[#677e97]">Choose the financial year that you wish to review. This will grant you access the records and data for that period.</p>
                  </div>
                  <div className="table-selector">
                    <table className="shadow-normalShadow w-full">
                      <thead className=" text-blue">
                        <tr>
                          <td className="p-[10px] w-[12%]">Id</td>
                          <td className="p-[10px] w-[45%]">Company name</td>
                          <td className="p-[10px] w-[28%]">Financial year</td>
                          <td className="p-[10px] text-center w-15">Action</td>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.masterCompanySelectList && this.state.masterCompanySelectList.map((x) => {
                          return (
                            <>
                              <tr>
                                <td>{x.idCompany}</td>
                                <td>{x.companyName}</td>
                                <td>{x.financialYear}</td>
                                <td><button className="secondary-btn w-full" onClick={() => this.selectedCompanyname(x.idCompany, x.companyName)}>Connect</button></td>
                              </tr>
                            </>
                          )
                        })}
                        {/*<tr>
                          <td>1</td>
                          <td>Mascot pump</td>
                          <td>2023-2024</td>
                          <td><button className="secondary-btn w-full justify-center">Connect</button></td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>Mascot pump2</td>
                          <td>2023-2024</td>
                          <td><button className="secondary-btn w-full justify-center">Connect</button></td>
                        </tr>*/}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* <div className="btn-grp flex justify-between mt-[30px] w-full">
                  <button className="secondary-btn" onClick={this.goToPreviousStep}>Previous <FontAwesomeIcon icon={faArrowLeftLong} /></button>
                  <button className="prm-btn" onClick={this.goToNextStep}>Next <FontAwesomeIcon icon={faArrowRightLong} /></button>
                </div> */}
              </div>
            )}
            {currentStep === 3 && (
              <div className="login-stepThree grid gap-[10px] justify-items-center">
                <div className="step-inner justify-items-center">
                  <div className="step-content w-[80%] mx-auto">
                    <h1 className="text-4xl font-bold mb-[10px] text-center text-[#3f8cff]">Sign in</h1>
                    {this.state.companyDetails.companyName && (
                      <p className="font-semibold mb-[10px] text-center text-[#3f8cff]">{this.state.companyDetails.companyName}</p>
                    )}
                    <p className="font-medium mb-[40px] text-center text-[#677e97]">Provide your username and password to log in and gain access to your account details and system features.</p>
                  </div>
                  <div className="login-fields grid gap-[10px] w-[60%]">
                    <div className="input-grp w-full">
                      <label>Username</label>
                      <input type="text"
                        className="login-input"
                        id="userName"
                        name="userName"
                        value={this.state.userDetails.userName}
                        ref={this.inputRef}
                        onChange={(event) => this.handleChange(event, "userName")} placeholder="Enter username" />
                    </div>
                    <div className="input-grp w-full">
                      <label>Password</label>
                      <input type="password"
                        className="login-input"
                        id="password"
                        name="password"
                        value={this.state.userDetails.password}
                        onChange={(event) => this.handleChange(event, "password")}
                        onKeyDown={(event) => this.handleKeyDown(event)} placeholder="Enter password" />
                    </div>
                  </div>
                </div>
                <div className="btn-grp flex justify-center mt-[30px] w-[60%]">
                  {/* <button className="secondary-btn" onClick={this.goToPreviousStep}>Previous <FontAwesomeIcon icon={faArrowLeftLong} /></button> */}
                  {/* <button className="prm-btn" onClick={this.handleLogin}>Sign In <FontAwesomeIcon icon={faArrowRightToBracket} /></button> */}
                  <button className="prm-btn" onClick={() => this.login('User')}>Sign In <FontAwesomeIcon icon={faArrowRightToBracket} /></button>
                </div>
              </div>
            )}

            {currentStep === 4 && (
              <div className="login-stepThree grid gap-[10px] justify-items-center">
                <div className="step-inner justify-items-center">
                  <div className="step-content w-[80%] mx-auto">
                    <h1 className="text-4xl font-bold mb-[10px] text-center text-[#3f8cff]">Admin sign in</h1>
                    {this.state.companyDetails.companyName && (
                      <p className="font-semibold mb-[10px] text-center text-[#3f8cff]">{this.state.companyDetails.companyName}</p>
                    )}
                    <p className="font-medium mb-[40px] text-center text-[#677e97]">Provide your username and password to log in and gain access to your account details and system features.</p>
                  </div>
                  <div className="login-fields grid gap-[10px] w-[60%]">
                    <div className="input-grp w-full">
                      <label>Admin Username</label>
                      <input type="text"
                        className="login-input"
                        id="userName"
                        name="userName"
                        value={this.state.userDetails.userName}
                        ref={this.inputRef}
                        onChange={(event) => this.handleChange(event, "userName")} placeholder="Enter username" />
                    </div>
                    <div className="input-grp w-full">
                      <label>Admin Password</label>
                      <input type="password"
                        className="login-input"
                        id="password"
                        name="password"
                        value={this.state.userDetails.password}
                        onChange={(event) => this.handleChange(event, "password")}
                        onKeyDown={(event) => this.handleKeyDown(event)} placeholder="Enter password" />
                    </div>
                  </div>
                </div>
                <div className="btn-grp flex justify-center mt-[30px] w-[60%]">
                  {/* <button className="secondary-btn" onClick={this.goToPreviousStep}>Previous <FontAwesomeIcon icon={faArrowLeftLong} /></button> */}
                  {/* <button className="prm-btn" onClick={this.handleLogin}>Sign In <FontAwesomeIcon icon={faArrowRightToBracket} /></button> */}
                  <button className="prm-btn" onClick={() => this.login('Admin')}> Admin sign in <FontAwesomeIcon icon={faArrowRightToBracket} /></button>
                </div>
              </div>
            )}

            {currentStep === 5 && (
              <div className="login-stepThree grid gap-[10px] justify-items-center">
                <div className="step-inner justify-items-center">
                  <div className="step-content w-[80%] mx-auto">
                    <h1 className="text-4xl font-bold mb-[10px] text-center text-[#3f8cff]">HOD Sign in</h1>
                    {this.state.companyDetails.companyName && (
                      <p className="font-semibold mb-[10px] text-center text-[#3f8cff]">{this.state.companyDetails.companyName}</p>
                    )}
                    <p className="font-medium mb-[40px] text-center text-[#677e97]">Provide your username and password to log in and gain access to your account details and system features.</p>
                  </div>
                  <div className="login-fields grid gap-[10px] w-[60%]">
                    <div className="input-grp w-full">
                      <label>HOD Username</label>
                      <input type="text"
                        className="login-input"
                        id="userName"
                        name="userName"
                        value={this.state.userDetails.userName}
                        ref={this.inputRef}
                        onChange={(event) => this.handleChange(event, "userName")} placeholder="Enter username" />
                    </div>
                    <div className="input-grp w-full">
                      <label>HOD Password</label>
                      <input type="password"
                        className="login-input"
                        id="password"
                        name="password"
                        value={this.state.userDetails.password}
                        onChange={(event) => this.handleChange(event, "password")}
                        onKeyDown={(event) => this.handleKeyDown(event)} placeholder="Enter password" />
                    </div>
                  </div>
                </div>
                <div className="btn-grp flex justify-between mt-[30px] w-[60%]">
                  {/* <button className="secondary-btn" onClick={this.goToPreviousStep}>Previous <FontAwesomeIcon icon={faArrowLeftLong} /></button> */}
                  {/* <button className="prm-btn" onClick={this.handleLogin}>Sign In <FontAwesomeIcon icon={faArrowRightToBracket} /></button> */}
                  <button className="prm-btn" onClick={() => this.login('HOD')}> HOD Sign In <FontAwesomeIcon icon={faArrowRightToBracket} /></button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default Login = withMsal(Login);